module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/bulb-1-88e6f418834f557c10231449440fc4e0.svg";